import React from 'react';
import { footerLinksLeft, footerLinksRight } from '../../../enums/footer-links';
import {
  CopyrightBarOrganism,
  TrustpilotWidgetOrganism,
  FooterMenuOrganism,
} from '../../organisms';
import LazyLoad from 'react-lazyload';

export const FooterMobileTemplate = () => {
  return (
    <>
      <footer className="bg-waldo-blue">
        <section className="block flex lg:flex-row flex-col max-w-screen-lg mx-auto px-5 pb-5">
          <div className="mt-7">
            <LazyLoad offset={100}>
              <img src="/images/icons/waldo-text.svg" />
            </LazyLoad>
          </div>
          <div className="flex flex-row w-full mt-2 justify-start">
            <TrustpilotWidgetOrganism
              templateId="5419b732fbfb950b10de65e5"
              styleHeight="20px"
              theme="dark"
            />
          </div>
        </section>
        <section className="block flex lg:flex-row flex-col justify-around max-w-screen-lg mx-auto px-5 pt-2.5 border-t border-white">
          <div className="flex flex-col justify-between pt-2.5 lg:w-1/2 sm:w-11/12 sm:mx-auto">
            <div className="mb-5 w-full flex flex-row ">
              <div className="w-full flex flex-col flex-wrap">
                <FooterMenuOrganism footerLinks={footerLinksLeft} />
              </div>
              <div className="w-full flex flex-col flex-wrap">
                <FooterMenuOrganism footerLinks={footerLinksRight} />
              </div>
            </div>
          </div>
        </section>
      </footer>
      <CopyrightBarOrganism />
    </>
  );
};
